import { configureStore } from "@reduxjs/toolkit";

import CompanyDetailReducer from "./Redux/CompanyDetail/CompanyDetailSlice";
import ThemeReducer from "./Redux/Theme/ThemeSlice";
import ActiveColumnReducer from "./Redux/ActiveColumn/ActiveColumnSlice";
import PermitDataReducer from "./Redux/PermitData/PermitDataSlice";

import DesignMasterDataReducer from "./Redux/MastersData/DesignMasterDataSlice";

import PackingChallanDataReducer from "./Redux/TransactionsData/PackingChallanDataSlice";
import SaleBillNoLRDataReducer from "./Redux/TransactionsData/SaleBillNoLRDataSlice";

import StockReportDataReducer from "./Redux/ReportsData/StockReportDataSlice";
import PackingChallanReportDataReducer from "./Redux/ReportsData/PackingChallanReportDataSlice";
import SaleReportDataReducer from "./Redux/ReportsData/SaleReportDataSlice";

import AccountNameListReducer from "./Redux/CommonListData/AccountNameListSlice";
import AgentNameListReducer from "./Redux/CommonListData/AgentNameListSlice";
import TransportNameListReducer from "./Redux/CommonListData/TransportNameListSlice";
import TeamMemberNameListReducer from "./Redux/CommonListData/TeamMemberNameListSlice";
import DesignNameListReducer from "./Redux/CommonListData/DesignNameListSlice";
import DesignGroupNameListReducer from "./Redux/CommonListData/DesignGroupNameListSlice";
import SupplyDesignNameListReducer from "./Redux/CommonListData/SupplyDesignNameListSlice";
import ProductNameListReducer from "./Redux/CommonListData/ProductNameListSlice";
import ColorNameListReducer from "./Redux/CommonListData/ColorNameListSlice";
import SizeNameListReducer from "./Redux/CommonListData/SizeNameListSlice";

import UserLevelReducer from "./Redux/UserLevel/UserLevelSlice";
import UserDetailReducer from "./Redux/UserDetail/UserDetailSlice";
import BarcodeRateSettingReducer from "./Redux/BarcodeRateSetting/BarcodeRateSettingSlice";

import BarcodePrintSettingReducer from "./Redux/BarcodeRateSetting/BarcodePrintSettingSlice";


const store = configureStore({
  reducer: {
    CompanyDetail: CompanyDetailReducer,
    Theme: ThemeReducer,
    ActiveColumn: ActiveColumnReducer,
    PermitData: PermitDataReducer,

    DesignMasterData: DesignMasterDataReducer,

    PackingChallanData: PackingChallanDataReducer,
    SaleBillNoLRData: SaleBillNoLRDataReducer,

    StockReportData: StockReportDataReducer,
    PackingChallanReportData: PackingChallanReportDataReducer,
    SaleReportData: SaleReportDataReducer,

    AccountNameList: AccountNameListReducer,
    AgentNameList: AgentNameListReducer,
    TransportNameList: TransportNameListReducer,
    TeamMemberNameList: TeamMemberNameListReducer,
    DesignNameList: DesignNameListReducer,
    DesignGroupNameList: DesignGroupNameListReducer,
    SupplyDesignNameList: SupplyDesignNameListReducer,
    ProductNameList: ProductNameListReducer,
    ColorNameList: ColorNameListReducer,
    SizeNameList: SizeNameListReducer,

    UserDetail: UserDetailReducer,
    UserLevel: UserLevelReducer,
    BarcodeRateSetting: BarcodeRateSettingReducer,

    BarcodePrintSetting: BarcodePrintSettingReducer,
  },
});

export default store;
